<mat-card class="location-context">
    <mat-card-content>
      <!-- Back -->
      <div class="nav-buttons" *ngIf="backButtonAvailable"> 
        <button class="back" mat-raised-button color="secondary" (click)="redirectBack()" data-cy="back">
          <mat-icon>arrow_back</mat-icon>
          <span>Back</span>
        </button>
      </div>

        <!-- Title -->
        <h1 data-cy="title">Centerline Selection</h1>
        
        <!-- Selected -->
        <div class="selected terminal">
            <span data-cy="selected-terminal">
                Terminal: <strong>{{ selectedTerminal }}</strong>
            </span>
        </div>
        <div class="selected centerline-group">
            <span data-cy="selected-centerline-group">
              Centerline Group: <strong>{{ selectedCenterlineGroup }}</strong>
            </span>
        </div>

        <!-- Terminal Selection -->
        <div class="intro">
          <span>Select the centerline to work on</span>
        </div>
        <div class="buttons">
          <div class="button" *ngFor="let centerline of centerlines">
            <button mat-raised-button color="primary" (click)="setSelectedCenterlineAndRedirect(centerline)" data-cy="centerline">
              {{ centerline }}
            </button>
          </div>
        </div>
    </mat-card-content>
  </mat-card>